import { render } from "./Label.vue?vue&type=template&id=8c3adc8e"
import script from "./Label.vue?vue&type=script&setup=true&lang=js"
export * from "./Label.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Label.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8c3adc8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8c3adc8e', __exports__)) {
    api.reload('8c3adc8e', __exports__)
  }
  
  module.hot.accept("./Label.vue?vue&type=template&id=8c3adc8e", () => {
    api.rerender('8c3adc8e', render)
  })

}


export default __exports__